export default __webpack_public_path__ + "static/media/showroom.315575da.png";